export default __webpack_public_path__ + "static/media/Eternal_university-removebg-preview 1.a42b9881.svg";